<main class="container-fluid">
  <app-admin-sidebar></app-admin-sidebar>
  <div class="profile-container gap-3">
    <div class="w-100 mb-5" *ngIf="organization">
      <a class="text-decoration-none" routerLink="../">
        <i class="bi bi-arrow-left me-2"></i>Terug naar overzicht
      </a>
      <h1 class="subtitle mt-3">Organisatie beheren</h1>
      <table class="profile-details">
        <tr>
          <td class="profile-text">Naam organisatie</td>
          <td>{{ organization.name }}</td>
        </tr>
        <tr>
          <td class="profile-text">Contactpersoon</td>
          <td>{{ organization.contactName }}</td>
        </tr>
        <tr>
          <td class="profile-text">Telefoonnummer contactpersoon</td>
          <td>{{ organization.contactPhone }}</td>
        </tr>
        <tr>
          <td class="profile-text">Adres</td>
          <td>{{ organization.address }}</td>
        </tr>
        <tr>
          <td class="profile-text">E-mailadres</td>
          <td>{{ organization.email }}</td>
        </tr>
        <tr>
          <td class="profile-text">Status</td>
          <td>{{ organization.active ? "Actief" : "Inactief" }}</td>
        </tr>
        <tr>
          <td class="profile-text">Aanmaakdatum organisatie</td>
          <td>{{ organization.created }}</td>
        </tr>
        <tr>
          <td class="profile-text">Beschrijving</td>
          <td>{{ organization.description }}</td>
        </tr>
      </table>
      <div class="action-buttons">
        <div class="row button-row">
          <button class="btn btn-primary profile-button mt-3">
            {{ organization.active ? "Organisatie deactiveren" : "Organisatie activeren" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</main>

